import type { SerializeFrom } from '@remix-run/node';
import type { loader } from '../root';

export function getOrganisationStructuredData(data?: SerializeFrom<typeof loader>) {
	if (!data) return {};
	return {
		'script:ld+json': {
			'@context': 'https://schema.org',
			'@type': 'Organization',
			'@id': data.webDomain + '/#organization',
			url: data.webDomain,
			logo: {
				'@type': 'ImageObject',
				'@id': data.webDomain + '/#logo',
				url: `${data.webDomain}/images/logo.png`,
			},
			name: 'The Print Bar',
			legalName: 'The Printing Bar Pty Ltd',
			description: 'Australian based wholehearted printing. Custom printed tees, totes, hoodies & more.',
			email: data.globalContent.mainEmail,
			telephone: data.globalContent.mainPhone,
			taxID: '25 638 038 525',
			iso6523Code: '0060:746906930',
			address: data.warehouses?.map(warehouse => ({
				'@type': 'PostalAddress',
				streetAddress: warehouse.streetAddress,
				addressLocality: warehouse.city,
				addressCountry: 'AU',
				addressRegion: warehouse.state,
				postalCode: warehouse.postCode,
			})),
			contactPoint: {
				'@type': 'ContactPoint',
				email: data.globalContent.mainEmail,
				telephone: data.globalContent.mainPhone,
				contactType: 'customer service',
				areaServed: 'AU',
				availableLanguage: 'en',
			},
			numberOfEmployees: {
				'@type': 'QuantitativeValue',
				minValue: 30,
				maxValue: 50,
			},
			sameAs: [
				'https://www.instagram.com/theprintbar',
				'https://www.linkedin.com/company/the-print-bar/',
				'https://www.facebook.com/PrintBar',
			],
		},
	};
}
